import { render, staticRenderFns } from "./Colors.vue?vue&type=template&id=bb0544f4&"
import script from "./Colors.vue?vue&type=script&lang=ts&"
export * from "./Colors.vue?vue&type=script&lang=ts&"
import style0 from "./Colors.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports